import { filter, compose, get, includes, __, identity } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringArrayProp } from '@mews/fp';
import { createAction } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { Task } from '@mews-commander/data-access';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import prefix from '../prefix';
import parentSelector from '../selector';
import { createScopedBaseEntitySelectors, createScopedEntitiesReducer } from './utils';

export const NAME = 'tasks';

export const TASKS_LOADED = prefix('TASKS_LOADED');
export const TASKS_ADDED = prefix('TASKS_ADDED');

export const setTasks = ({ tasks, scope }: { tasks: Task[]; scope: string }) =>
    createAction(TASKS_LOADED, { entities: tasks }, { scope });
export const setTask = ({ task, scope }: { task: Task; scope: string }) =>
    createAction(TASKS_LOADED, { entities: [task] }, { scope });

export const [getTasks, getTasksByIds, getTaskByOwnerId, getTask] = createScopedBaseEntitySelectors<
    ApplicationState,
    Task,
    typeof NAME,
    'enterpriseId'
>(parentSelector, NAME, 'enterpriseId');

export const getCurrentEnterpriseTasks = createSelector(
    getCurrentEnterpriseId,
    identity<ApplicationState>,
    (enterpriseId, state) => getTasks(state, { enterpriseId })
);

export const getCurrentEnterpriseTasksByServiceOrderIds = createSelector(
    getCurrentEnterpriseTasks,
    getStringArrayProp('serviceOrderIds'),
    (tasks, serviceOrderIds) => filter(compose(includes(__, serviceOrderIds), get('serviceOrderId')), tasks)
);

export const tasksReducer = createScopedEntitiesReducer({
    FETCH_SUCCESS: TASKS_LOADED,
    ADD_SUCCESS: TASKS_ADDED,
});
